/* colors */
export const PRIMARY_COLOR = "#ffc400"
export const PRIMARY_COLOR_DARKER = "#ebb402"
export const FONT_COLOR = "#fff"
export const BG_COLOR = "#fff"
export const CHMER_COLOR = "#daa700"
export const FEELER_COLOR = "#47bdbe"
